import _ from 'lodash';
import { sanitizeHtmlContent } from 'shared/utils';
import { ExternalLinkViewer } from './external-link-viewer';
import contentStyles from '../../content-style.module.scss';
import { KNOWLEDGE_TYPES } from 'shared/constants';
import { DOCUMENT_EDITOR_MODES } from 'shared/constants/document-editor.constants';
import styles from './knowledge-viewers.module.scss';
import { DocumentEditor, useDocumentEditor } from 'src/components/document-editor';
import { DocumentDownload } from '../../document-download/document-download.component';
import { Skeleton } from 'antd';

const ContentSkeleton = () => (
  <div className={styles.contentSkeleton}>
    <Skeleton
      active
      title={{ width: '60%' }}
      paragraph={{ rows: 3, width: ['100%', '90%', '70%'] }}
    />
    <Skeleton
      active
      title={{ width: '40%' }}
      paragraph={{ rows: 4, width: ['95%', '100%', '85%', '60%'] }}
    />
    <Skeleton
      active
      title={{ width: '50%' }}
      paragraph={{ rows: 3, width: ['100%', '80%', '90%'] }}
    />
  </div>
);

export function KnowledgeViewers({
  id,
  title,
  link,
  captionsUrl,
  content,
  type,
  isContent,
  smartFormatMode,
  ownerIds,
  linked,
  close,
}) {
  const { shouldUseDocumentEditor, canRenderInEditor } = useDocumentEditor(link, type);

  if (isContent && smartFormatMode) {
    if (_.isNil(content)) {
      return <ContentSkeleton />;
    }

    return (
      <div
        id="content-container"
        className={contentStyles.contentContainer}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtmlContent(content),
        }}
      />
    );
  }

  if (type === KNOWLEDGE_TYPES.VIDEO) {
    // Only render <track> when captions exist; an empty <track> triggers CORS enforcement that breaks Safari playback.
    return (
      <video
        className={styles.video}
        title={title}
        src={link}
        controls
        {...(captionsUrl && { crossOrigin: 'anonymous' })}>
        {captionsUrl && (
          <track kind="captions" src={captionsUrl} srcLang="en" label="English" default />
        )}
      </video>
    );
  }

  // Handle office document types (spreadsheets, documents, presentations)
  if (shouldUseDocumentEditor) {
    // Render editor for spreadsheets when feature is supported, otherwise show download
    if (canRenderInEditor) {
      return (
        <div className={styles.documentEditorWrapper}>
          <DocumentEditor
            itemId={id}
            title={title}
            mode={DOCUMENT_EDITOR_MODES.VIEW}
            link={link}
            fallback={<DocumentDownload knowledge={{ id, title, link, type, ownerIds, linked }} />}
          />
        </div>
      );
    }
    return <DocumentDownload knowledge={{ id, title, link, type, ownerIds, linked }} />;
  }

  return <ExternalLinkViewer id={id} title={title} link={!isContent && link} />;
}
